<template>
    <div>
        <NavBar
            :articles="$page.props.nav.articles"
            :tags="$page.props.nav.tags"
        ></NavBar>

        <slot />
    </div>

    <SiteFooter />
</template>

<script>
import NavBar from '../components/NavBar.vue'
import SiteFooter from '../components/SiteFooter.vue'

export default {
    components: {
        NavBar,
        SiteFooter,
    },
}
</script>
